const ScoreInfoCard = ({
  icon,
  title,
  subtitle,
  tableNote = "",
  tableHeaders = [],
  tableRows = [],
  features = [],
  insight,
  color = "#147EF5",
 bgColor="",
 sectionText="",
 sectionSubText=""
}) => {
  return (
    <div
      className="score-card-box my-5"
      style={{
        "--theme-color": color,
      }}
    >
      {/* Header */}
      <div className="d-flex align-items-center gap-3 mb-4">
        <div>
          <img src={icon} alt={title} />
        </div>

        <div>
          <h5 className="FS24FW500 mb-1 top-section-text">{title}</h5>
          <p className="FS16FW500 fw-400 mb-0 plus-sans">{subtitle}</p>
        </div>
      </div>
      {sectionText && (
          <div className="academy-highlight-box mb-4" style={{background:bgColor}}>
       {sectionText}
          </div> 
        )}
      {sectionSubText &&
        <p className="mb-4 quote-para FS16FW500 fw-600">{sectionSubText}</p>
      }
      {/* Dynamic Table */}
      {tableRows.length > 0 && (
        <div>
          {tableNote && <p className="plus-sans FS16FW500">{tableNote}</p>}
          <DynamicTable headers={tableHeaders} rows={tableRows} />
        </div>
      )}

      {/* Dynamic Features */}
      {features.length > 0 && (
        <div className="row">
          {features.map((item, i) => (
            <div className="col-md-6 mb-5" key={i}>
              <div className="feature-border plus-sans">
                <h3 className="FS20FW500 fw-600 mb-2" style={{wordBreak:"break-word"}}>{item.title}</h3>
                <p className="FS16FW500 fw-400 mb-0">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Reusable insight */}
      {insight && (
        <InfoNotice title={insight.title} description={insight.description} />
      )}
    </div>
  );
};

const InfoNotice = ({
  title = "Important",
  description = "",
  icon = "/images/web-new-images/icons/idea-bulb.svg",
  className = "",
}) => {
  return (
    <div className={`info-notice ${className}`}>
      <div className="d-flex align-items-start gap-2">
        {icon && (
          <img src={icon} alt={title} className="info-icon" loading="lazy" />
        )}

        <div>
          <h3 className="mb-2 fw-600 FS20FW500">{title}</h3>

          <p className="mb-0 title FS16FW500">{description}</p>
        </div>
      </div>
    </div>
  );
};

const DynamicTable = ({ headers = [], rows = [] }) => {
  return (
    <div className="table-responsive custom-table-wrapper">
      <table className="table custom-table mb-0">
        <thead>
          <tr>
            {headers.map((heading, index) => (
              <th className="FS20FW500 fw-600 ai-heading" key={index}>
                {heading}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ScoreInfoCard;
